import request from '@/request/request'


// 查询任务列表
export function listIntegratedTask(query) {
    return request({
        url: '/api/task-server/integratedTask/list',
        method: 'get',
        params: query
    })
}

// 查询任务详细
export function getIntegratedTaskById(id) {
    return request({
        url: '/api/task-server/integratedTask/' + id,
        method: 'get'
    })
}

// 新增任务
export function addIntegratedTask(data) {
    return request({
        url: '/api/task-server/integratedTask',
        method: 'post',
        data: data
    })
}

// 修改任务
export function updateIntegratedTask(data) {
    return request({
        url: '/api/task-server/integratedTask/edit',
        method: 'post',
        data: data
    })
}

// 删除任务
export function delIntegratedTask(id) {
    return request({
        url: '/api/task-server/integratedTask/delete/' + id,
        method: 'post'
    })
}


// 关闭任务
export function closedIntegratedTask(data) {
    return request({
        url: '/api/task-server/integratedTask/closed',
        method: 'post',
        data: data
    })
}

// 完成任务
export function finishIntegratedTask(data) {
    return request({
        url: '/api/task-server/integratedTask/finish',
        method: 'post',
        data: data,
        headers: {
            ignoreValidate: true
        }
    })
}


// 查询任务详细app免token
export function getAPPIntegratedTaskById(id) {
    return request({
        url: '/api/task-server/integratedTask/' + id,
        method: 'get',
        headers: {
            ignoreValidate: true
        }
    })
}
